/* Built In Imports */
// import Head from 'next/head';

/* External Imports */
import { Box } from '@chakra-ui/react';
import config from '@config';
/* Internal Imports */
/* Components */

import { ProgramLanguageSelectionProvider } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
// import RenderSections from '@in-person/Common/RenderSections';
import RenderSections from '@in-person/RenderSection';

import WrapLayout from '@Layout/WrapLayout';
import HeadComponent from '@components/Utility/HeadComponent';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  getCurrentRegion,
} from 'services/commonService';
import {
  fetchDetailsIeo,
  fetchIEOPrgData,
  fetchIEOSupportData,
  getLandingPaths,
  fetchDetailsIeoInPerson,
} from 'services/ieoService';
import { useState, useEffect } from 'react';
import ModeOFProgramModal from '@in-person/Components/Modal/ModeOFProgramModal';
import PrsProgramFinderModal from '@in-person/Components/Modal/ProgramFinderPrs';

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Inner Engineering Online Landing page Data
 */

const InnerEngineeringInPerson = ({ region, language, pageData }) => {
  console.log(pageData, 'pagedata');
  const [programData, setProgramData] = useState('');
  const [supportData, setSupportData] = useState('');
  useEffect(() => {
    localData();
  }, [pageData]);

  const localData = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const reg = await getCurrentRegion(urlParams.get('country'));
    if (pageData && reg?.country) {
      pageData.country = reg.country;
      const ieoPrgList = await fetchIEOPrgData(reg?.country?.toUpperCase());
      // const ieoPrgList = await fetchIEOPrgData('us'.toUpperCase());
      setProgramData(ieoPrgList?.data);
      const supData = await fetchIEOSupportData(reg.country, language);
      // const supData = await fetchIEOSupportData('us', 'en');
      setSupportData(supData?.data);
    }
  };

  return (
    <Box w="100%" float="left" pos="relative">
      <ProgramLanguageSelectionProvider>
        <WrapLayout pageData={pageData}>
          <HeadComponent
            data={pageData?._seoMetaTags || pageData?.seoFields}
            availableLocals={pageData?.availableLocales}
          >
            {''}
          </HeadComponent>
          <Box as="section" p="0" maxW="1920px" w="100%" m="0 auto">
            {pageData?.body?.length &&
              pageData.body[0]?.value?.map((section, index) => {
                return (
                  <RenderSections
                    pageData={pageData}
                    section={section}
                    region={region}
                    lang={language}
                    key={index}
                    // key={nanoid(4)}
                    csrData={programData}
                    supportData={supportData}
                  />
                );
              })}
            <ModeOFProgramModal
              lang={language}
              region={region}
              pageData={pageData}
              pageName={'in-person'}
              prgData={'crs'}
            />
            <PrsProgramFinderModal />
          </Box>
        </WrapLayout>
      </ProgramLanguageSelectionProvider>
    </Box>
  );
};

export const getStaticPaths = async () => {
  const paths = config.USE_LOCAL_URL
    ? [
        '/in/en/inner-engineering/inner-engineering-us-eoe-online',
        '/ca/en/inner-engineering/inner-engineering-us-eoe-online',
        '/us/en/inner-engineering/inner-engineering-us-eoe-online',
      ]
    : await getLandingPaths(
        'L1',
        '/inner-engineering/inner-engineering-us-eoe-online',
        null,
        'landing_page_child'
      );
  return {
    paths,
    fallback: false,
  };
};
export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetailsIeoInPerson(region, language, '', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: !!preview,
      hideTopMenu: true,
      showHeader: false,
    },
  };
};

export default InnerEngineeringInPerson;
